function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  fill: "#FFFFFF",
  d: "M243,485.3c-61.9,0-124-23.6-171.1-70.8C26.2,368.6,1,307.9,1,243.2S26.2,117.6,71.9,72 c94.5-94.3,248-94.3,342.4,0l0,0c94.3,94.6,94.3,248.3,0,342.5C367.2,461.7,305,485.3,243,485.3z"
}), React.createElement("g", {
  id: "_x30_3_00000070086105149525090510000001508195642830826142_"
}, React.createElement("path", {
  fill: "#BBAACC",
  d: "M410.9,411.2c-92.8,92.7-243.1,92.7-335.9,0c-92.7-92.7-92.7-243.1,0-335.9c92.7-92.7,243.1-92.7,335.9,0 C503.7,168.1,503.7,318.5,410.9,411.2z"
})), React.createElement("g", {
  id: "_x30_3_00000122705630885267907690000003060155396602460298_"
}, React.createElement("path", {
  fill: "#FFFFFF",
  d: "M414.1,244.1c0,95.8-77.7,173.5-173.5,173.5c-95.8,0-173.5-77.7-173.5-173.5c0-95.8,77.7-173.5,173.5-173.5 C336.4,70.6,414.1,148.3,414.1,244.1z"
})), React.createElement("g", {
  id: "_x30_3_00000016782203243940040250000009957169014354828202_"
}, React.createElement("path", {
  fill: "#BBAACC",
  d: "M240.6,411.7C148.2,411.7,73,336.5,73,244.1c0-92.5,75.2-167.7,167.7-167.7c92.5,0,167.7,75.2,167.7,167.7 C408.3,336.5,333.1,411.7,240.6,411.7z M240.6,81.4c-89.7,0-162.7,73-162.7,162.7c0,89.7,73,162.7,162.7,162.7 s162.7-73,162.7-162.7C403.3,154.4,330.3,81.4,240.6,81.4z"
})), React.createElement("g", null, React.createElement("path", {
  fill: "#FFFFFF",
  d: "M83.2,90l17.9-16.8l4.4,4.7l-12.7,12l4.7,5l11.2-10.6l4.4,4.7l-11.2,10.6l8.6,9.1l-5.2,4.9L83.2,90z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M116.5,81.2L116.5,81.2c-5.1-7.7-3.1-18,5.2-23.5c8.3-5.5,18.4-3.2,23.4,4.5l0.1,0.1c5,7.7,3.1,17.9-5.2,23.4 C131.6,91.1,121.5,88.9,116.5,81.2z M139,66.5L139,66.5c-3.1-4.7-9-6.3-13.8-3.2c-4.8,3.1-5.6,9.1-2.6,13.7l0.1,0.1 c3,4.6,8.9,6.3,13.7,3.1C141.2,77,142,71.1,139,66.5z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M152.8,61.2l-7-17l6.6-2.7l7,16.9c2,4.9,5.5,6.4,9.5,4.7s5.4-5.1,3.5-9.8l-7-17.1l6.6-2.7l6.9,16.8 c3.7,9,0.5,15.6-7.5,18.9C163.1,72.4,156.4,70,152.8,61.2z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M182.9,30l6.4-1.4l18.9,16.3l-4.1-19.4L211,24l6.7,31.6l-5.9,1.3L192.2,40l4.2,20.1l-6.9,1.5L182.9,30z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M223.2,22.6l12.6-0.3c10.1-0.3,17.3,6.5,17.5,15.6l0,0.1c0.2,9.1-6.6,16.3-16.7,16.5L224,54.9L223.2,22.6z  M230.5,28.8l0.5,19.4l5.5-0.1c5.8-0.1,9.6-4.2,9.5-9.9l0-0.1c-0.1-5.7-4.2-9.6-10-9.5L230.5,28.8z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M272.1,23.9l6.5,1l8.9,34.2l-7.3-1.1l-1.9-7.6l-13.5-2l-4,6.7l-7.2-1.1L272.1,23.9z M276.7,43.7l-2.7-11 l-5.8,9.7L276.7,43.7z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M301.8,36.9l-9.4-2.8l1.9-6.3l25.6,7.8l-1.9,6.3l-9.4-2.8l-7.5,24.6l-6.8-2.1L301.8,36.9z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M327.8,39.1l6.5,2.8l-12.9,29.6l-6.5-2.8L327.8,39.1z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M335.2,59.5L335.2,59.5c4.8-7.9,14.9-10.5,23.4-5.3c8.5,5.2,10.7,15.3,5.9,23.1l0,0.1 c-4.8,7.8-14.9,10.4-23.4,5.2C332.6,77.4,330.4,67.4,335.2,59.5z M358.1,73.6L358.1,73.6c2.9-4.8,1.9-10.8-3-13.8 c-4.9-3-10.6-1.2-13.5,3.5l0,0.1c-2.9,4.7-1.8,10.8,3,13.7C349.5,80.1,355.2,78.3,358.1,73.6z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M381.6,70.5l4.8,4.4l-2.3,24.9l13.4-14.6l5.2,4.7l-21.8,23.8l-4.5-4.1l2.3-25.7L365,99l-5.2-4.7L381.6,70.5z"
})), React.createElement("g", null, React.createElement("path", {
  fill: "#BBAACC",
  d: "M107.7,244.1v-0.2c0-18.8,14.4-33.5,33.9-33.5c13.2,0,21.6,5.5,27.4,13.4l-13.4,10.4 c-3.7-4.5-7.9-7.6-14.1-7.6c-9,0-15.4,7.7-15.4,17.1v0.2c0,9.7,6.4,17.2,15.4,17.2c6.7,0,10.7-3.1,14.6-7.8l13.4,9.6 c-6.1,8.4-14.3,14.6-28.5,14.6C122.5,277.4,107.7,263.3,107.7,244.1L107.7,244.1z"
}), React.createElement("polygon", {
  fill: "#BBAACC",
  points: "174.6,211.5 192.9,211.5 192.9,235.8 216,235.8 216,211.5 233.9,211.5 233.9,276.4 216,276.4 216,251.7 192.5,251.7 192.5,276.4 174.6,276.4 174.6,211.5  "
}), React.createElement("polygon", {
  fill: "#BBAACC",
  points: "174.6,211.5 192.9,211.5 192.9,235.8 216,235.8 216,211.5 233.9,211.5 233.9,276.4 216,276.4 216,251.7 192.5,251.7 192.5,276.4 174.6,276.4 174.6,211.5  "
}), React.createElement("path", {
  fill: "#BBAACC",
  d: "M311.6,266.8l9.9-11.9c6.4,5.1,13.4,7.7,20.9,7.7c4.9,0,7.4-1.7,7.4-4.4v-0.3c0-2.8-2.1-4.2-11-6.3 c-13.8-3.1-24.4-7-24.4-20.3v-0.4c0-11.9,9.4-20.5,24.8-20.5c10.9,0,19.4,2.9,26.3,8.5l-8.9,12.5c-5.9-4.2-12.3-6.3-17.9-6.3 c-4.3,0-6.4,1.7-6.4,4.1v0.3c0,3,2.2,4.3,11.3,6.3c14.9,3.2,24.1,8.1,24.1,20.2v0.3c0,13.1-10.4,21-26,21 C330.4,277.4,319.6,273.8,311.6,266.8L311.6,266.8z"
}), React.createElement("path", {
  fill: "#BBAACC",
  d: "M363.4,232.4L363.4,232.4c0-4.5,3.6-8.3,8.2-8.3c4.6,0,8.2,3.7,8.2,8.2v0c0,4.5-3.6,8.2-8.2,8.2 C367,240.5,363.4,236.8,363.4,232.4L363.4,232.4z M377.8,232.3L377.8,232.3c0-3.4-2.6-6.3-6.2-6.3c-3.5,0-6.2,2.8-6.2,6.3v0 c0,3.4,2.6,6.2,6.2,6.2C375.1,238.6,377.8,235.7,377.8,232.3L377.8,232.3z M368.2,228.2h3.7c2,0,3.4,0.9,3.4,2.6 c0,1.2-0.6,2-1.6,2.4l1.8,2.6h-3l-1.4-2h-0.6v2h-2.4V228.2L368.2,228.2z M371.7,231.8c0.7,0,1-0.3,1-0.8c0-0.5-0.4-0.8-1-0.8h-1.2 v1.6H371.7L371.7,231.8z"
}), React.createElement("path", {
  fill: "#BBAACC",
  d: "M238.5,276.4h19l4.6-11.6H287l4.6,11.6H311l-27.4-64.9h-17.7L238.5,276.4L238.5,276.4z M281.8,250.5h-14.6 l7.3-18.4L281.8,250.5L281.8,250.5z"
})));

var SvgChasFoundation = function SvgChasFoundation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "CHAS_Foundation",
    x: "0px",
    y: "0px",
    viewBox: "0 0 485 485.3",
    style: {
      enableBackground: "new 0 0 485 485.3"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChasFoundation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CHAS Foundation.20b9833a.svg";
export { ForwardRef as ReactComponent };